// reducers/teamReducer.js

import { GET_TEAM_DETAILS_SUCCESS, DELETE_TEAM_SUCCESS } from "../actions/types";
import {
  ALL_TEAMS,
  LOGOUT,
  SELECTED_TEAM,
  SELECTED_CLOCK,
} from '../actions/teamActions.js';

const INITIAL_STATE = {
  allTeams: [],
  selectedTeam: null,
};
const initialState = {
  teamData: null,
  loading: false,
  error: null,
};

const teamReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEAM_DETAILS_SUCCESS:
      return {
        ...state,
        teamData: action.payload,
        loading: false,
        error: null,
      };
    case DELETE_TEAM_SUCCESS:
      return {
        ...state,
        teamData: null,
        loading: false,
        error: null,
      };
    case ALL_TEAMS:
      return {...state, allTeams: action.payload};
    case SELECTED_TEAM:
      return {...state, selectedTeam: action.payload};
    case SELECTED_CLOCK:
      return {...state, selectedClock: action.payload};
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }


};

export default teamReducer;
